import { Component, OnInit, Input } from '@angular/core';
import { MediaService } from 'app/components/media/media.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { SearchService } from 'app/components/search/search.service';
import { ProductsService } from 'app/components/products/products.service';
import { ModalSimpleComponent } from '../modal-simple/modal-simple.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as uuid from 'uuid';


@Component({
  selector: 'app-edit-product-multimedia',
  templateUrl: './edit-product-multimedia.component.html',
  styleUrls: ['./edit-product-multimedia.component.css']
})
export class EditProductMultimediaComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  maxImageSize: number = 614400;
  maxFileSize:number = 16777216
  maxFileCount: number = 3;

  @Input() exhibitorData: object = {
    images: [],
    files: []
  };

  constructor(private mediaService: MediaService, private catalogueService: CatalogueService, private exhitorsService: ExhitorsService,
  private searchService: SearchService, private productsService: ProductsService, private modalService: NgbModal) { }

  removeImage(item) {

    let index = this.exhibitorData['images'].indexOf(item);

    if (index != -1) {
      this.exhibitorData['images'].splice(index, 1);
      this.reorganizeBtn();
    }

  }

  imageFileChange($event) {

    const file = $event.srcElement.files[0];
    
    if( this.exhibitorData['images'].length == this.exhibitorData['imageProductLimit'] ) {
      let alertData = {
        alertType: 'error',
        alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.IMAGES_LIMIT_ERROR'
      }

      this.openSimpleModal(alertData);
      return;
    }

    if( file.size >= this.maxImageSize ) {
      let alertData = {
        alertType: 'error',
        alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.IMAGES_LIMIT_SIZE'
      }

      this.openSimpleModal(alertData);
      return;
    }


    let extraRoute = 'product/' + this.exhibitorData['productId'] + '/images';

    let addFileIn = {
      file: file,
      catalogueId: this.catalogueService.getProperty('id'),
      productId: this.exhibitorData['productId'],
      name: file.name,
      path: `ecatalogue/${this.catalogueService.getProperty('sapCode')}/${extraRoute}/${uuid.v4()}.${file.type.replace(/(.*)\//g, '')}`
      }

      this.addImage(addFileIn);
  }

  addImage(addFileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mediaService.addFile(addFileIn)
      .subscribe((data: object) => {
        this.addImageOk(data);
      },
        error => {
          this.addImageError(error);
        });

  }

  addImageOk(data) {

    this.loader.count--;

    this.exhibitorData['images'].push({
      id: data.id,
      visibilityOrder: this.exhibitorData['images'].length,
      url: data.url
    });

    this.reorganizeBtn();

  }

  addImageError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  reorganizeProductImages(reorganizeProductImagesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mediaService.reorganizeProductImages(reorganizeProductImagesIn)
      .subscribe((data: object) => {
        this.reorganizeProductImagesOk(data);
      },
        error => {
          this.reorganizeProductImagesError(error);
        });

  }

  reorganizeProductImagesOk(data) {

    this.loader.count--;

    /** Set data to model */

  }

  reorganizeProductImagesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

    if (error.code === '000029') {
      this.openSimpleModal(alertData);
    }

  }

  openSimpleModal(alertData)  {
    const modalRef = this.modalService.open(ModalSimpleComponent);
    modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
    modalRef.componentInstance.modalInformation = alertData.alertMessage;
    modalRef.componentInstance.isHtml = false;
  }

  reorganizeBtn() {

    let imagesUrl: Array<any> = [];

    for (let i = 0; i < this.exhibitorData['images'].length; i++) {
      imagesUrl.push(this.exhibitorData['images'][i]['url']);
    }

    let reorganizeProductImagesIn = {
      productId: this.exhibitorData['productId'],
      order: imagesUrl
    }

    this.reorganizeProductImages(reorganizeProductImagesIn);

  }

  fileChange($event) {

    const file = $event.srcElement.files[0];

    if( this.exhibitorData['files'].length === this.maxFileCount ) {
      let alertData = {
        alertType: 'error',
        alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.FILE_LIMIT_ERROR'
      }

      this.openSimpleModal(alertData);
      return;
    }

    if(file.size >= this.maxFileSize) {
      let alertData = {
        alertType: 'error',
        alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.FILE_LIMIT_SIZE'
      }

      this.openSimpleModal(alertData);
      return;
    }


    let addFileIn = {
      file: file,
      catalogueId: this.catalogueService.getProperty('id'),
      productId: this.exhibitorData['productId'],
      name: file.name
      }

      this.addFile(addFileIn);
  }

  addFile(addFileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mediaService.addFile(addFileIn)
      .subscribe((data: object) => {
        this.addFileOk(data);
      },
        error => {
          this.addFileError(error);
        });

  }

  addFileOk(data) {

    this.loader.count--;

    let file = {
      id: data.id,
      url: data.url
    }

    this.exhibitorData['files'].push(file);

  }

  addFileError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  removeFile(item) {

    let index = this.exhibitorData['files'].indexOf(item);

    if (index != -1) {

      let deleteFileIn = {
        fileId: item.id
      }

      this.deleteFile(deleteFileIn);

      this.exhibitorData['files'].splice(index, 1);

    }

  }

  deleteFile(deleteFileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mediaService.deleteFile(deleteFileIn)
      .subscribe((data: object) => {
        this.deleteFileOk(data);
      },
        error => {
          this.deleteFileError(error);
        });

  }

  deleteFileOk(data) {

    this.loader.count--;

    /** Set data to model */

  }

  deleteFileError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getCatalogueAndProduct(getCatalogueAndProductIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.searchService.getCatalogueAndProduct(getCatalogueAndProductIn)
      .subscribe((data: object) => {
        this.getCatalogueAndProductOk(data);
      },
        error => {
          this.getCatalogueAndProductError(error);
        });

  }

  getCatalogueAndProductOk(data) {
    this.loader.count--;
    this.exhibitorData['files'] = data._embedded.files;
  }

  getCatalogueAndProductError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getProductsImages(getProductsImagesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProductsImages(getProductsImagesIn)
      .subscribe((data: object) => {
        this.getProductsImagesOk(data);
      },
        error => {
          this.getProductsImagesError(error);
        });

  }

  getProductsImagesOk(data) {
    this.loader.count--;
    if(data._embedded.images.length > 0){
      this.exhibitorData['images'] = data._embedded.images;
    }
  }

  getProductsImagesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }



  ngOnInit() {

    this.exhibitorData['images'] = this.exhibitorData['images'] || [];
    this.exhibitorData['files'] = this.exhibitorData['files'] || [];

    if (this.exhibitorData['productId']) {

      let getProductsImagesIn = {
        productId: this.exhibitorData['productId'],
        projectionType: 'detail'
      };

      this.getProductsImages(getProductsImagesIn);

      let getCatalogueAndProductIn = {
        catalogueId: this.catalogueService.getProperty('id'),
        productId: this.exhibitorData['productId']
      }

      this.getCatalogueAndProduct(getCatalogueAndProductIn);

    }

  }

}
